import {
  SUPER_ADMIN_SET_COMPANIES,
  SUPER_ADMIN_SET_NEW_DATE_FOR_COMPANY,
  SUPER_ADMIN_REMOVE_USER_TO_BRAND,
  SUPER_ADMIN_ADD_USER_TO_BRAND,
  SUPER_ADMIN_SET_NEW_COMPANY_ADMIN
} from '../constants/action-types/super-admin';

const initialState = {
  company: null,
  company_brands: null,
  all_users: null,
};

const mainAdminReducer = (state = initialState, action) => {
  switch (action.type) {
    case SUPER_ADMIN_SET_COMPANIES:
      return { ...state, company: action.payload };
    case 'SUPER_ADMIN_SET_ALL_COMPANIES_BRANDS':
      return { ...state, company_brands: action.payload };
    case 'SUPER_ADMIN_SET_ALL_USERS':
      return { ...state, all_users: action.payload };

    case SUPER_ADMIN_REMOVE_USER_TO_BRAND: {
      const { user, brandId } = action.payload;

      const needBrand = state.company_brands.find(
        brandItem => brandItem._id === brandId,
      );

      const neededBrandIndex = state.company_brands.findIndex(
        brandItem => brandItem._id === brandId,
      );

      const neededUserIdIndex = needBrand.users.findIndex(
        userId => userId === user,
      );

      const neededBrandWithoutUser = {
        ...needBrand,
        users: [
          ...needBrand.users.slice(0, neededUserIdIndex),
          ...needBrand.users.slice(neededUserIdIndex + 1),
        ],
      };

      const newBrand = [
        ...state.company_brands.slice(0, neededBrandIndex),
        neededBrandWithoutUser,
        ...state.company_brands.slice(neededBrandIndex + 1),
      ];

      return {
        ...state,
        company_brands: newBrand,
      };
    }

    case SUPER_ADMIN_ADD_USER_TO_BRAND: {
      const { user, brandId } = action.payload;

      const neededBrand = state.company_brands.find(
        brand => brand._id === brandId,
      );

      const neededBrandIndex = state.company_brands.findIndex(
        brand => brand._id === brandId,
      );

      const neededBrandWithUser = {
        ...neededBrand,
        users: [...neededBrand.users, user],
      };

      const newBrands = [
        ...state.company_brands.slice(0, neededBrandIndex),
        neededBrandWithUser,
        ...state.company_brands.slice(neededBrandIndex + 1),
      ];

      return {
        ...state,
        company_brands: newBrands,
      };
    }

    case SUPER_ADMIN_SET_NEW_DATE_FOR_COMPANY:
      const neededCompanyIndex = state.company.findIndex(
        companyItem => companyItem._id === action.payload._id,
      );
      return {
        ...state,
        company: [
          ...state.company.slice(0, neededCompanyIndex),
          action.payload,
          ...state.company.slice(neededCompanyIndex + 1),
        ],
      };

    case SUPER_ADMIN_SET_NEW_COMPANY_ADMIN: {
      const oldUserAdmin = state.all_users.find(user => (user.companyAdmin === true && user.company === action.payload.company));

      if (oldUserAdmin._id === action.payload._id) {
        return state;
      } else {
        const oldUserAdminIndex = state.all_users.findIndex(
          user => (user.companyAdmin === true && user.company === action.payload.company),
        );

        const newUserWithoutAdmin = { ...oldUserAdmin, companyAdmin: false };

        const oldUserWithoutAdminIndex = state.all_users.findIndex(
          user => user._id === action.payload._id,
        );
        const newUsers = [...state.all_users];
        newUsers[oldUserAdminIndex] = newUserWithoutAdmin;
        newUsers[oldUserWithoutAdminIndex] = action.payload;

        return {
          ...state,
          all_users: newUsers,
        };
      }
    };

    default:
      return state;
  }
};

export default mainAdminReducer;
